export const ZERO_FIAT_AMOUNT = {
  currencyCode: "INR",
  currencySymbol: "₹",
  value: 0,
};

// We don't have a default origin for India
export const DEFAULT_FLIGHT_ORIGIN = null;
